import { useState, useEffect } from 'react'
import { instance } from '@/config/axios'
import { urls }     from '@/config/urls'
import { VehicleSettingsResponse } from '@/config/types/Vehicles'

const { server } = urls

export function useVehicleSettings(enabled: boolean) {
  const [data,    setData]    = useState<VehicleSettingsResponse | null>(null)
  const [loading,setLoading] = useState(false)
  const [error,  setError]   = useState<string | null>(null)

  const fetchSettings = async () => {
    setLoading(true)
    setError(null)
    try {
      const resp = await instance.get<VehicleSettingsResponse>(
        server.settings.vehicle
      )
      setData(resp.data)
    } catch (err: any) {
      setError(err.response?.data?.description || err.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (enabled) {
      fetchSettings()
    }
  }, [enabled])

  return { data, loading, error, refetch: fetchSettings }
}
